import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import * as commonActions from '../common/redux/actions';
import { CollectionSettingCard } from './collection/CollectionSettingCard';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { COLLECTION, FIELD } from 'drapcode-constant';
export class CollectionEdit extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.loadProjectDetailCollections({ projectId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
    actions.loadCollectionItems({ projectId, collectionName: 'role', version });
  }

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (nextProps.match.url !== this.props.match.url) {
      const { projectId, collectionId, version } = nextProps.match.params;
      nextProps.actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    }
    return true;
  };

  render() {
    const { collections, actions, history, homeActions, commonActions, match, home, common } =
      this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionsPending,
      loadProjectCollectionDetailPending,
      selectedCollection,
      currentCollectionListPage,
      totalCollectionPages,
      permissionFlags,
      items,
    } = collections;
    console.log('WARN: common :>> ', common);
    const { updatedCollections } = common;
    const { snippets } = home;
    console.log('WARN: updatedCollections :>> ', updatedCollections);
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    return (
      <CommonPageComponent parentClassName="collections-collection-edit">
        <CollectionHeaderNav
          label={types.FIELDS}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionsPending={loadProjectCollectionsPending}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionsPending || loadProjectCollectionDetailPending ? (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionsPending || loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        ) : (
          <CollectionSettingCard
            collections={collections}
            actions={actions}
            homeActions={homeActions}
            commonActions={commonActions}
            version={version}
            projectId={projectId}
            history={history}
            updatedCollections={updatedCollections}
            currentCollectionListPage={currentCollectionListPage}
            totalCollectionPages={totalCollectionPages}
            collectionFlag={permissionsArray.includes(COLLECTION)}
            fieldFlag={permissionsArray.includes(FIELD)}
            snippets={snippets}
            roles={items}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionEdit);
